import api from './api'
import CallHelper from '@/helpers/call.helper'

class TaskService {
    async getAll(params = {}) {
        return CallHelper.getDataRecursive('/task', params, (data, response) => {
            if(data.length) {
                data = [...data, ...response.data.tasks]
            } else {
                data = response.data.tasks
            }

            return data
        },)
    }

    async get(params = {}) {
        return api.get('/task', params)
    }

    async getInstance(uuid) {
        return api.get('/task/' + uuid)
    }

    async create(task) {
        return api.post('/task', task)
        .then(response => response.data);
    }

    async modify(uuid, task) {
        return api.patch('/task/' + uuid, task)
            .then(response => {
                return response.data
            })
    }

    async delete(task) {
        return api.delete('/task/' + task.uuid)
            .then(response => response.data);
    }
}

export default new TaskService();
